/**
 * Shared time formatting utilities.
 * Used by both the DigiBox vault and the main CRM messaging system.
 */

/** Parse a date string from coreBOS, treating naive timestamps as UTC */
function parseDate(dateStr: string): Date {
  // coreBOS returns timestamps without timezone (e.g. "2026-04-04 22:09:05")
  // These are UTC. Append 'Z' so JS doesn't interpret them as local time.
  if (dateStr && !dateStr.includes("T") && !dateStr.includes("Z") && !dateStr.includes("+")) {
    return new Date(dateStr.replace(" ", "T") + "Z");
  }
  return new Date(dateStr);
}

/** Relative time string in Italian (e.g. "2m fa", "ieri", "3g fa") */
export function timeAgo(dateStr: string): string {
  if (!dateStr) return "";
  const diff = Date.now() - parseDate(dateStr).getTime();
  const mins = Math.floor(diff / 60000);
  if (mins < 1) return "adesso";
  if (mins < 60) return `${mins}m fa`;
  const hrs = Math.floor(mins / 60);
  if (hrs < 24) return `${hrs}h fa`;
  const days = Math.floor(hrs / 24);
  if (days === 1) return "ieri";
  if (days < 30) return `${days}g fa`;
  return parseDate(dateStr).toLocaleDateString("it-IT", {
    day: "2-digit",
    month: "short",
    year: "numeric",
  });
}

/** Format a date string as a full Italian date (e.g. "04 aprile 2026") */
export function formatDate(dateStr: string): string {
  if (!dateStr) return "";
  return parseDate(dateStr).toLocaleDateString("it-IT", {
    day: "2-digit",
    month: "long",
    year: "numeric",
  });
}

/** Format a date string with time (e.g. "04 apr 2026, 14:30") */
export function formatDateTime(dateStr: string): string {
  if (!dateStr) return "";
  return parseDate(dateStr).toLocaleDateString("it-IT", {
    day: "2-digit",
    month: "short",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
}
